import React, { useState } from 'react'
import {
    CCard,
    CCardHeader,
    CCardBody,
    CButton,
    CTable,
    CTableHead,
    CTableHeaderCell,
    CTableBody,
    CTableRow,
    CTableDataCell,
    CBadge,
    CTooltip,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalFooter
} from '@coreui/react'
import { cilCommentBubble, cilX, cilSend } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { toast } from 'react-toastify';

import CookieFunctions from '../../functions/CookieFunctions'
import { statusColor, timeOffNames } from '../../Constants'

import '../../styles/AllRequests.css'

export default function AllRequests({ history, setHistory }) {
    const [cancelModalVisible, setCancelModalVisible] = useState(false);
    const [requestToCancel, setRequestToCancel] = useState(null)

    const driverType = CookieFunctions.getDriverType();
    const country = CookieFunctions.getCountry();

    function openCancelModal(i) {
        setRequestToCancel(i)
        setCancelModalVisible(true)
    }

    function closeCancelModal() {
        setCancelModalVisible(false)
        setRequestToCancel(null)
    }

    function canCancel(d) {
        var today = new Date();
        today.setHours(23, 59, 59, 999);

        return new Date(d) > today
    }

    function cancelRequest() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        formData.append("reqId", history[requestToCancel].id)
        formData.append("status", history[requestToCancel].timeOffStatus)
        formData.append("startDate", history[requestToCancel].startDate)

        fetch("/api/drivers/cancelRequest",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                var msg;
                if (history[requestToCancel].timeOffStatus === "Pending Approval") {
                    msg = "Your request has been cancelled"
                } else if (history[requestToCancel].timeOffStatus === "Approved") {
                    msg = "Your cancel request has been sent"
                }
                toast.success(msg, {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });

                const newHistory = [...history];
                if (newHistory[requestToCancel]) {
                    newHistory[requestToCancel] = { ...newHistory[requestToCancel], timeOffStatus: history[requestToCancel].timeOffStatus === "Pending Approval" ? "Cancelled" : "Pending Cancellation" };
                    setHistory(newHistory);
                }
            } else {
                throw new Error("This request could not be cancelled")
            }
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored"
            });
        })

        setRequestToCancel(null)
        setCancelModalVisible(false)
    }

    return (
        <CCard >
            <CCardHeader>All Requests</CCardHeader>
            <CCardBody>
                <CTable responsive id="allRequests">
                    <CTableHead >
                        <CTableRow>
                            <CTableHeaderCell scope="col">Type</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Start Date</CTableHeaderCell>
                            <CTableHeaderCell scope="col">End Date</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Duration</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Approver</CTableHeaderCell>
                            <CTableHeaderCell scope="col"><span style={{ padding: 0, display: 'flex', justifyContent: 'center' }}>Comments</span></CTableHeaderCell>
                            <CTableHeaderCell scope="col"><span style={{ padding: 0, display: 'flex', justifyContent: 'center' }}>Status</span></CTableHeaderCell>
                            <CTableHeaderCell scope="col">Cancel</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {history ? history.map((req, i) => {
                            return (
                                <CTableRow key={i}>
                                    <CTableDataCell>{timeOffNames[driverType][country][req.timeOffType]}</CTableDataCell>
                                    <CTableDataCell>{parseFloat(req.duration) > 0.5 ? req.startDate.split("T")[0] : `${req.startDate.split("T")[0]} ${req.startDate.split("T")[1]}`}</CTableDataCell>
                                    <CTableDataCell>{parseFloat(req.duration) > 0.5 ? req.endDate.split("T")[0] : `${req.endDate.split("T")[0]} ${req.endDate.split("T")[1]}`}</CTableDataCell>
                                    <CTableDataCell>{parseFloat(req.duration)} Day(s)</CTableDataCell>
                                    <CTableDataCell>{req.approver}</CTableDataCell>
                                    <CTableDataCell align='middle'>
                                        {req.employeeComments !== "" ?
                                            <div style={{ display: 'flex', justifyContent: 'center', verticalAlign: 'middle' }}>
                                                <CTooltip
                                                    className='fs-4'
                                                    content={req.employeeComments}
                                                    placement="top"
                                                >
                                                    <CIcon icon={cilCommentBubble} />
                                                </CTooltip>
                                            </div>
                                            : null}
                                    </CTableDataCell>
                                    <CTableDataCell align='middle'>
                                        <CBadge className='fs-6' style={{ color: statusColor[req.timeOffStatus]["text"], backgroundColor: statusColor[req.timeOffStatus]["bg"], justifyContent: 'center', display: 'flex' }} shape='rounded-pill'>{req.timeOffStatus}</CBadge>
                                    </CTableDataCell>
                                    {canCancel(req.startDate) && req.timeOffStatus !== "Pending Cancellation" && req.timeOffStatus !== "Cancelled" && req.timeOffStatus !== "Rejected" ?
                                        <CTableDataCell>
                                            <CTooltip content='Delete'>
                                                <CButton color='danger' onClick={() => { openCancelModal(i) }} className='m-1'>
                                                    <CIcon icon={cilX} />
                                                </CButton>
                                            </CTooltip>
                                        </CTableDataCell>
                                        :
                                        <>
                                            {req.timeOffStatus === "Pending Cancellation" ?
                                                <CTableDataCell align='middle'>
                                                    <div style={{ display: 'flex', justifyContent: 'center', verticalAlign: 'middle' }}>
                                                        <CTooltip
                                                            className='fs-4'
                                                            content={"Email sent to dispatcher for approval"}
                                                            placement="top"
                                                        >
                                                            <CIcon icon={cilSend} />
                                                        </CTooltip>
                                                    </div>
                                                </CTableDataCell> : <CTableDataCell />}
                                        </>
                                    }
                                </CTableRow>
                            )
                        }) : null}
                    </CTableBody>
                </CTable>
            </CCardBody>
            <CModal visible={cancelModalVisible} alignment='center' onClose={closeCancelModal}>
                <CModalHeader><CModalTitle>Are you sure you want to cancel this request?</CModalTitle></CModalHeader>
                <CModalFooter>
                    <CButton color="dark" variant='outline' onClick={closeCancelModal}>Close</CButton>
                    <CButton color="danger" onClick={() => { cancelRequest(requestToCancel) }}>Confirm</CButton>
                </CModalFooter>
            </CModal>
        </CCard>)
}